var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCartAdd = function SvgCartAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m21.25 5.75-1.297 7.044a3 3 0 0 1-2.95 2.456H8.458a3 3 0 0 1-2.941-2.412L3.74 3.956a1.5 1.5 0 0 0-1.47-1.206H1.75M9.5 7h3.25m0 0H16m-3.25 0V3.75m0 3.25v3.25M9.25 19a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0m9 0a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0"
  })));
};
export default SvgCartAdd;